import React from "react";
import Title from "../layouts/Title";
import {
  projectOne,
  projectTwo,
  projectThree,
  projectFour,
  projectFive,
  projectSix,
  projectSeven,
  rrdash,
} from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          // title="Check these out on my github"
          des="Sample Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="React-Redux Dashboard"
          des="A sleek visualization app built with ReactJS Redux, featuring real-time data integration using custom APIs and interactive charts."
          src={rrdash}
          // githubLink="https://github.com/mihirc0111/AfterSchoolDiaries-HTML-CSS-JS-BootStrap-Website"
          websiteLink="https://rrempdashboard.netlify.app/dashboard"
        />

        <ProjectsCard
          title="Movie TMDB"
          des="A movie collection app powered by the TMDB API, built with NextJS for a seamless, fast, and interactive user experience."
          src={projectThree}
          // githubLink="https://github.com/mihirc0111/Secrets"
          websiteLink="https://mytmdbapp.vercel.app/"
        />

        <ProjectsCard
          title="Mario & Mushroom"
          des="A fun and interactive Mario-themed game built with ReactJS, featuring dynamic player movement and food collection."
          src={projectFive}
          // githubLink="https://github.com/mihirc0111/Weather-Website-UsingAPI--node.js--express.js"
          websiteLink="https://mario-n-mush.vercel.app/"
        />
        <ProjectsCard
          title="Recipes"
          des="An interactive SPA built with ReactJS, showcasing a dynamic collection of recipes filtered by various categories for a personalized cooking experience."
          src={projectOne}
          // githubLink="https://github.com/mihirc0111/IPL-Predictor-Mihir"
          websiteLink="https://elit-vitae-recipe.netlify.app/"
        />
        <ProjectsCard
          title="Life-Made-Easy"
          des="A dynamic blog website built with the MEAN stack, featuring a diverse range of genres for an engaging reading experience."
          src={projectTwo}
          // githubLink="https://github.com/mihirc0111/Mi-Blog-Van"
          websiteLink="https://elitvitae.netlify.app/#/"
        />

        <ProjectsCard
          title="Crypto Currency Chart"
          des="A dynamic crypto app built with ReactJS, leveraging CoinDesk API to fetch and display details, stats, and prices."
          src={projectFour}
          // githubLink="https://github.com/mihirc0111/Weather-Website-UsingAPI--node.js--express.js"
          websiteLink="https://vikasx-crypto-app-0cf209i.netlify.app/"
        />

        {/* <ProjectsCard
          title="Face Detection"
          des=" This project uses various libraries like to detect human face from a given image, detect a face from a live -webcam video and to create an attendance system."
          src={projectSix}
          githubLink="https://github.com/mihirc0111/Face-Detection-ML-Project-Python.git"
          websiteLink=""
        /> */}
      </div>
    </section>
  );
};

export default Projects;
